/* @jsx h */
import { defineComponent, h } from "vue";
import { useLocalization } from "@lemmonhq/uikit";
import { weekdayNames } from "./dates";

type Props = { days: number[]; onChange: (days: number[]) => void };

// Seven toggles, Monday first, with shortcuts.
export const WeekdayPicker = defineComponent<Props>({
  name: "WeekdayPicker",
  props: ["days", "onChange"],
  setup(props) {
    const { t } = useLocalization();
    const names = weekdayNames("short");
    const toggle = (d: number) =>
      props.onChange(props.days.includes(d) ? props.days.filter((x) => x !== d) : [...props.days, d].sort());
    const preset = (label: string, days: number[]) => (
      <button type="button" class="btn btn-ghost btn-xs" onClick={() => props.onChange(days)}>
        {label}
      </button>
    );

    return () => (
      <div>
        <div class="join">
          {names.map((name, i) => (
            <button
              key={i}
              type="button"
              class={["btn join-item btn-sm min-w-11", props.days.includes(i + 1) ? "btn-primary" : "btn-ghost border-base-300"].join(" ")}
              onClick={() => toggle(i + 1)}
            >
              {name}
            </button>
          ))}
        </div>
        <div class="mt-1 flex flex-wrap gap-1">
          {preset(t("workday.schedule.every_day"), [1, 2, 3, 4, 5, 6, 7])}
          {preset(t("workday.schedule.weekdays"), [1, 2, 3, 4, 5])}
          {preset(t("workday.schedule.weekends"), [6, 7])}
          {preset(t("workday.schedule.on_demand"), [])}
        </div>
      </div>
    );
  },
});
